import { memoize } from 'lodash'

import Base from './base'

export default class HasMany extends Base {
  constructor (model, name, options = {}) {
    super(model, name, options)

    this.foreignKey = options.foreignKey
    this.through = options.through ?? null
  }

  // Gets records from collection matching matchAttributes.
  // Memoizes the function.
  //
  getRecords (record, collection, matchAttributes) {
    // Function to retrieve records
    const selector = (_record, collection, matchAttributes) => collection.getAll(matchAttributes)

    // Memoize using a custom resolver for resolving the cache key
    this.recordsSelector ||= memoize(selector, (record, collection) => {
      return [record.id, record.hashCode(), collection.hashCode()].join('-')
    })

    return this.recordsSelector(record, collection, matchAttributes)
  }

  getResult (record) {
    const attributes = {}

    if (this.through) {
      const throughAssociation = this.getAssociation(this.model, this.through)
      const sourceAssociation = this.getAssociation(throughAssociation.associatedModel(), this.name)
      const sourceModel = sourceAssociation.associatedModel()

      // Fetch ids from association to go through
      const ids = throughAssociation.getResult(record).map((o) => o.id).toArray()
      attributes[sourceAssociation.foreignKey] = ids

      return this.getRecords(record, sourceModel.collection(), attributes)
    } else {
      attributes[this.foreignKey] = record.id

      return this.getRecords(record, this.associatedModel().collection(), attributes)
    }
  }
}
